export default __webpack_public_path__ + "static/media/smsLogo.526ec354.png";